import React, { useEffect } from "react";

import FASTable from "../../../../../components/Tables/FASTable";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import {
  BankAcRecPayMonth,
  BankRecPayMonthFun,
  BankRecPayMonthFunn,
} from "../../../../../Redux/Slice/Fas/DayBook Analysis/Bank/BankSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";
import { Col, Row } from "react-bootstrap";

export default function BankAccountRecAndPay({
  accountGroup,
  bankName,
  startDate,
  endDate,
}) {
  const dispatch = useDispatch();
  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");

  useEffect(() => {
    dispatch(BankRecPayMonthFunn());
    dispatch(
      BankAcRecPayMonth({
        Firm,
        Year: YearId,
        selectedIds: accountGroup.join(","),
        BankIDs: bankName.join(","),
        startDate: startDate,
        endDate: endDate,
      }),
    );
  }, [accountGroup, bankName, startDate, endDate, dispatch]);

  const { BankAcRecPayMonthdata } = useSelector((state) => state.BankSlice);

  const getRows = BankAcRecPayMonthdata?.AcRecMonthDtl?.map((label, index) => ({
    // srNumber: index + 1,
    AcName: label.AcName,
    Apr: label.Apr,
    May: label.May,
    Jun: label.Jun,
    Jul: label.Jul,
    Aug: label.Aug,
    Sep: label.Sep,
    Oct: label.Oct,
    Nov: label.Nov,
    Dec: label.Dec,
    Jan: label.Jan,
    Feb: label.Feb,
    Mar: label.Mar,
    Receipts: label.Receipts,
  }));

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Ac Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Receipts", key: "Receipts", align: "right", format: "true" },
  ];

  const getRows1 = BankAcRecPayMonthdata?.AcPayMonthDtl?.map(
    (label, index) => ({
      // srNumber: index + 1,
      AcName: label.AcName,
      Apr: label.Apr,
      May: label.May,
      Jun: label.Jun,
      Jul: label.Jul,
      Aug: label.Aug,
      Sep: label.Sep,
      Oct: label.Oct,
      Nov: label.Nov,
      Dec: label.Dec,
      Jan: label.Jan,
      Feb: label.Feb,
      Mar: label.Mar,
      Payment: label.Payment,
    }),
  );

  const getColumns1 = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Ac Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Payment", key: "Payment", align: "right", format: "true" },
  ];

  if (BankAcRecPayMonthdata === "no" || BankAcRecPayMonthdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <>
      <Row>
        <Col xl={6}>
          <div style={{ marginTop: "20px" }}>
            <div
              style={{
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
              }}
            >
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour5
                      : iscolourDark?.Colour4,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour11,
                  padding: "18px 22px",
                  margin: 0,
                }}
              >
                <h2
                  style={{
                    fontSize: "18px",
                    margin: 0,
                    letterSpacing: "1px",
                  }}
                >
                  RECEIPT
                </h2>
              </div>

              <FASTable columns={getColumns} data={getRows} />
            </div>
          </div>
        </Col>
        <Col xl={6}>
          <div style={{ marginTop: "20px" }}>
            <div
              style={{
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
              }}
            >
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour5
                      : iscolourDark?.Colour4,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour11,
                  margin: 0,
                  padding: "14px",
                }}
              >
                <h2
                  style={{
                    fontSize: "18px",
                    margin: 0,
                    fontWeight: "600",
                    letterSpacing: "1px",
                  }}
                >
                  PAYMENT
                </h2>
              </div>

              <FASTable columns={getColumns1} data={getRows1} />
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
}
